import {vec3, vec4} from 'gl-matrix';
import * as Stats from 'stats-js';
import * as DAT from 'dat-gui';
import Square from './geometry/Square';
import Mesh from './geometry/Mesh';
import OpenGLRenderer from './rendering/gl/OpenGLRenderer';
import Camera from './Camera';
import {setGL} from './globals';
import {readTextFile} from './globals';
import ShaderProgram, {Shader} from './rendering/gl/ShaderProgram';
import Texture from './rendering/gl/Texture';

// Define an object with application parameters and button callbacks
const controls = {
  // Extra credit: Add interactivity
  DOF: false,
  Focus: 0.75,
  Bloom: false,
  Extract: 0.6,
  Brightness: 1.0,
  // BloommSize: 11.0,
  // Bloomsigma: 7.0,
  Kuwahara: false,
  Radius: 5.0,
  Rain: false,
  Stop: false,
};

let square: Square;

// TODO: replace with your scene's stuff

let obj0: string;
let mesh0: Mesh;

let tex0: Texture;


var timer = {
  deltaTime: 0.0,
  startTime: 0.0,
  currentTime: 0.0,
  updateTime: function() {
    var t = Date.now();
    t = (t - timer.startTime) * 0.001;
    timer.deltaTime = t - timer.currentTime;
    timer.currentTime = t;
  },
}


function loadOBJText() {
  obj0 = readTextFile('./src/resources/obj/wahoo.obj')
}


function loadScene() {
  square && square.destroy();
  mesh0 && mesh0.destroy();

  square = new Square(vec3.fromValues(0, 0, 0));
  square.create();

  mesh0 = new Mesh(obj0, vec3.fromValues(0, 0, 0));
  mesh0.create();

  tex0 = new Texture('./src/resources/textures/wahoo.bmp')
}


function main() {
  // Initial display for framerate
  const stats = Stats();
  stats.setMode(0);
  stats.domElement.style.position = 'absolute';
  stats.domElement.style.left = '0px';
  stats.domElement.style.top = '0px';
  document.body.appendChild(stats.domElement);

  // Add controls to the gui
  const gui = new DAT.GUI();
  gui.add(controls, 'DOF');
  gui.add(controls, 'Focus', 0.01, 1).step(0.01);
  gui.add(controls, 'Bloom');
  gui.add(controls, 'Extract', 0, 1).step(0.01);
  gui.add(controls, 'Brightness', 0, 2).step(0.01);
  gui.add(controls, 'Kuwahara');
  gui.add(controls, 'Radius', 0, 10).step(1.0);
  gui.add(controls, 'Rain');
  gui.add(controls, 'Stop');

  // get canvas and webgl context
  const canvas = <HTMLCanvasElement> document.getElementById('canvas');
  const gl = <WebGL2RenderingContext> canvas.getContext('webgl2');
  if (!gl) {
    alert('WebGL 2 not supported!');
  }
  // `setGL` is a function imported above which sets the value of `gl` in the `globals.ts` module.
  // Later, we can import `gl` from `globals.ts` to access it
  setGL(gl);

  // Initial call to load scene
  loadScene();

  const camera = new Camera(vec3.fromValues(0, 9, 25), vec3.fromValues(0, 9, 0));

  const renderer = new OpenGLRenderer(canvas, controls);
  renderer.setClearColor(0, 0, 0, 1);
  gl.enable(gl.DEPTH_TEST);

  const standardDeferred = new ShaderProgram([
    new Shader(gl.VERTEX_SHADER, require('./shaders/standard-vert.glsl')),
    new Shader(gl.FRAGMENT_SHADER, require('./shaders/standard-frag.glsl')),
    ]);

  standardDeferred.setupTexUnits(["tex_Color"]);
  standardDeferred.setFar(camera.far);
  standardDeferred.setNear(camera.near);

  function tick() {
    camera.update();
    stats.begin();
    gl.viewport(0, 0, window.innerWidth, window.innerHeight);
    if(!controls.Stop)
    {
      timer.updateTime();
    }
    renderer.updateTime(timer.deltaTime, timer.currentTime);
    renderer.controls = controls;
    

    standardDeferred.bindTexToUnit("tex_Color", tex0, 0);
    


    renderer.clear();
    renderer.clearGB();
    // TODO: pass any arguments you may need for shader passes
    renderer.deferredShader.setCamerapos(vec4.fromValues(camera.controls.eye[0], camera.controls.eye[1], camera.controls.eye[2], 1.0));
    renderer.deferredShader.setHeight(window.innerHeight);
    renderer.deferredShader.setWidth(window.innerWidth);
    // forward render mesh info into gbuffers
    renderer.renderToGBuffer(camera, standardDeferred, [mesh0]);
    // render from gbuffers into 32-bit color buffer
    renderer.renderFromGBuffer(camera);
    //apply 32-bit post and tonemap from 32-bit color to 8-bit color
    renderer.renderPostProcessHDR(camera);
    //apply 8-bit post and draw
    renderer.renderPostProcessLDR();

    stats.end();
    requestAnimationFrame(tick);
  }

  window.addEventListener('resize', function() {
    renderer.setSize(window.innerWidth, window.innerHeight);
    camera.setAspectRatio(window.innerWidth / window.innerHeight);
    camera.updateProjectionMatrix();
  }, false);

  renderer.setSize(window.innerWidth, window.innerHeight);
  camera.setAspectRatio(window.innerWidth / window.innerHeight);
  camera.updateProjectionMatrix();

  // Start the render loop
  tick();
}


function setup() {
  timer.startTime = Date.now();
  loadOBJText();
  main();
}

setup();



// WEBPACK FOOTER //
// ./src/main.ts